import { formatDistanceToNow } from "date-fns";

export default function DateLabel({ timestamp }: { timestamp?: string | number }) {
  const date = timestamp && new Date(timestamp);
  const relativeTime = date && formatDistanceToNow(date, { addSuffix: true });

  return <span>{relativeTime}</span>;
}